import { c as _c } from "react/compiler-runtime";
import { Button } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import clsx from "clsx";
import { FC, MouseEventHandler } from "react";
export interface FormButtonsProps {
  isLoading?: boolean;
  onPrevious?: MouseEventHandler;
  showSubmit?: boolean;
  submitLabel?: string;
  className?: string;
  isEmbedded?: boolean;
}
const FormButtons: FC<FormButtonsProps> = t0 => {
  const $ = _c(20);
  const {
    isLoading,
    onPrevious,
    showSubmit: t1,
    submitLabel,
    className,
    isEmbedded: t2
  } = t0;
  const showSubmit = t1 === undefined ? true : t1;
  const isEmbedded = t2 === undefined ? false : t2;
  const {
    t
  } = useApplicationTranslation();
  let t3;
  if ($[0] !== className) {
    t3 = clsx("w-full", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !isEmbedded;
  let t5;
  if ($[2] !== t4) {
    t5 = clsx("flex gap-s", {
      "items-center justify-between s:justify-start": t4
    });
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== isLoading || $[5] !== onPrevious || $[6] !== t) {
    t6 = onPrevious && <Button disabled={isLoading} onClick={onPrevious} className="whitespace-nowrap" variant="ghost" paddingX={false} size="md">{t("link_back_previous")}</Button>;
    $[4] = isLoading;
    $[5] = onPrevious;
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isLoading || $[9] !== showSubmit || $[10] !== submitLabel || $[11] !== t) {
    t7 = showSubmit && <Button type="submit" size="md" isLoading={isLoading} iconEnd="Right" fullWidth={true}>{submitLabel ?? t("form_button_next")}</Button>;
    $[8] = isLoading;
    $[9] = showSubmit;
    $[10] = submitLabel;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t8) {
    t9 = <div className={t3}>{t8}</div>;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default FormButtons;